const DELAY_TIMEOUT = 5000;
export function delayUntilIdle(callback) {
  const delay = window.requestIdleCallback || window.setTimeout;
  const delayOptions = delay === window.requestIdleCallback ? {
    timeout: DELAY_TIMEOUT
  } : 0;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '0 | { timeout: number; }' is not... Remove this comment to see the full error message
  delay(callback, delayOptions);
}